export const AUTHENTICATION_TYPES = {
    RAINBOW: "RAINBOW",
    SAML: "SAML",
    OIDC: "OIDC"
}
 
export const SERVER_NAMES = {
    COM: "openrainbow.com",
    COM_CN: "myopenrainbow.com.cn",
    HEALTH: "openrainbow.health",
    NET: "openrainbow.net",
    CPAAS: "cpaaspreprod.openrainbow.net",
    ORG: "openrainbow.org",
    MONACO: "rainbow-one.monacodatacenter.com"
}
